import { configureStore } from "@reduxjs/toolkit";

import levelsReducer from "./slices/levelsSlice";
import userReducer from "./slices/userSlice";
import userHistoryReducer from "./slices/userHistorySlice";
import gameReducer from "./slices/gameSlice";
import rewardsReducer from "./slices/rewardsSlice";

export const store = configureStore({
  reducer: {
    levels: levelsReducer,
    user: userReducer,
    userHistory: userHistoryReducer,
    game: gameReducer,
    rewards: rewardsReducer,
  },
});

